module.exports = __webpack_public_path__ + "static/media/clockBlue.4641204c.svg";